import { init } from '@plausible-analytics/tracker'
import "./src/styles/main.css"

init({
  domain: 'ytmp4.media',
  endpoint: 'https://pb.ytmp3tube.com/api/event'
})